module.exports = __webpack_public_path__ + "static/media/Farming Wind Cock.c6cc5471.svg";